import React from 'react';
import styled from 'styled-components';
import { Flex } from 'antd';
import { ButtonMainRed } from './button/ButtonMainRed';
import { MainMenuNav } from './MainMenuNav';

interface IMenuButton {

}

const DivContentStyled = styled.div`
  position: absolute;
  top: 0; 
  left: 0;
  right: 0; 
  bottom: 0;
  z-index: 2;
  padding: 50px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 5px;
  }
`;

const FlexLogoStyled = styled(Flex)`

  @media (max-width: 768px) {
    padding: 50px 20px 0px 20px;
  }
`;

const FlexStyled = styled(Flex)`
  color: #fff;
  text-transform: uppercase;
  font-size: 36px;
  flex: 1;
  
 
  && h1 {
    margin: 0;
    font-size: 36px;
    text-align: center;
    width: 50%;
    font-family: "futura-pt", sans-serif;
  }

  && h3 {
    margin: 15px 0px;
    font-size: 36px;
    font-weight: 300;
    width: 50%;
    text-align: center;
    font-family: "futura-pt", sans-serif;
  }

  @media (max-width: 768px) {
    margin-top: 0px;

    && h1, && h3 {
      width: 100%;
      font-size: 30px;
    }
  }
`;

export const ContentHeaderMain: React.FC<IMenuButton> = () => (
    <DivContentStyled>
        <Flex justify={'flex-end'}>
            <MainMenuNav />
        </Flex>
        <FlexLogoStyled justify={'space-between'} align={'center'} >
            {/* <Logo /> */}
        </FlexLogoStyled>
        <FlexStyled vertical align={'center'} justify={'center'}>
            <h1>North American Architectural Woodwork Standards (NAAWS)</h1>
            <h3>The proven standard</h3>
            <Flex justify={'center'}>
                <ButtonMainRed text={'Get Your Free Copy'} route={'https://naaws.com/get-naaws-4-0/'} targetBlank={true}/>
            </Flex>
        </FlexStyled>
    </DivContentStyled>
);
